import { Injectable } from '@angular/core';
import { PersistingStorageService } from './persisting-storage';

@Injectable()
export class StorageService {
  constructor(private _persistingStorageService: PersistingStorageService) {}

  getPersistingStorageKeys(): Promise<string[]> {
    return this._persistingStorageService.keys();
  }

  async getIfRemembersUsername(): Promise<{ username: string | null }> {
    let isUsernameRemembered = await this._persistingStorageService
      .get('setting.remember.username')
      .catch((err) => console.error(err));
    isUsernameRemembered =
      typeof isUsernameRemembered !== 'undefined' &&
      isUsernameRemembered != 'false'
        ? true
        : false;
    const username = isUsernameRemembered
      ? await this._persistingStorageService.get('user.username')
      : null;
    return { username };
  }

  async setRememberUsername(
    username: string,
    rememberUsername: boolean,
  ): Promise<void> {
    if (rememberUsername) {
      await this._persistingStorageService.set(
        'setting.remember.username',
        rememberUsername,
      );
      await this._persistingStorageService.set('user.username', username);
    } else {
      await this._persistingStorageService.set(
        'setting.remember.username',
        rememberUsername,
      );
      await this._persistingStorageService.remove('user.username');
    }
  }

  setCsrfToken(csrfToken: string): Promise<void> {
    return this._persistingStorageService.set('csrfToken', csrfToken);
  }

  getCsrfToken(): Promise<string> {
    return this._persistingStorageService.get('csrfToken');
  }

  clearCsrfToken(): Promise<void> {
    return this._persistingStorageService.remove('csrfToken');
  }
}
